module.exports = __webpack_public_path__ + "img/logo.c7334c27.png";